import React from 'react';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonButtons, IonMenuButton, IonContent } from '@ionic/react';
import ExpensesContent from '../components/ExpensesContent';

const Expenses: React.FC = () => (
  <IonPage>
    <IonHeader>
      <IonToolbar>
        <IonButtons slot="start">
          <IonMenuButton menu="main-menu" />
        </IonButtons>
        <IonTitle>Expenses</IonTitle>
      </IonToolbar>
    </IonHeader>
    <IonContent fullscreen className="bg-gray-50 dark:bg-gray-900">
      <ExpensesContent />
    </IonContent>
  </IonPage>
);

export default Expenses;
